import clsx from 'clsx';
import ImageIcon from 'images/icons/Image.svg';
import { Product } from 'types/settings';

import { Image } from 'components/Image';
import { Stars } from 'components/Stars';
import { Text } from 'components/Text';

import styles from './Slide.module.scss';

interface SlideProps {
  product: Product;
}

export function Slide({ product }: SlideProps) {
  const { title, image_src, overall_rating, reviews_count, price, url } =
    product;

  const productTitleMarkup = title && <Text lineClamp={3}>{title}</Text>;

  const classes = clsx(styles.VerticalSlide, !image_src && styles.NoImage);

  const mainImageMarkup = (
    <div className={styles.ImageWrapper}>
      {image_src ? (
        <img loading="lazy" alt={title} src={image_src} />
      ) : (
        <Image alt={title} source={ImageIcon} />
      )}
    </div>
  );

  const showStars = !!(reviews_count && overall_rating);

  const starsMarkup = showStars && (
    <div className={styles.SlideStars}>
      <Stars
        value={overall_rating}
        connectedRight={<Text variation="subdued">({reviews_count})</Text>}
      />
    </div>
  );

  const priceMarkup = <Text>{price}</Text>;

  return (
    <div className={classes}>
      <a href={url}>
        <div className={styles.VerticalSlideInner}>
          {mainImageMarkup}
          <div className={styles.SlideContent}>
            {productTitleMarkup}
            {starsMarkup}
            {priceMarkup}
          </div>
        </div>
      </a>
    </div>
  );
}
